import * as React from "react";

import { useQuestionnaireContainer } from "@teamprevent/common/questionnaires";
import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { ContextAwareCheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/ContextAwareCheckboxQuestion";

import { consultationMethodOptions } from "../models";

export const DataPrivacySection = () => {
    const { readonly } = useQuestionnaireContainer();

    return (
        <AccordionQuestionnaireSection
            title="Introduction and Data Privacy"
            id="IntroductionAndDataPrivacy"
        >
            <DropdownQuestion
                hideDivider
                inline
                readonly={readonly}
                questionConfig={({ id: "IntroductionAndDataPrivacyConsultationMethod", questionText: "Consultation Method" })}
                options={consultationMethodOptions}
                mandatory
            />
            <ContextAwareCheckboxQuestion
                preserveInitialQuestionText
                hideDivider
                questionConfig={{
                    id: "IntroductionAndDataPrivacyProceedConsent",
                    questionText: "Thank you, we are talking today as your manager has referred you to Occupational Health "
                            + "in order to determine how best to support you. By proceeding with the consultation today you will "
                            + "be providing Optima Health with consent to store and process any personal and health related information "
                            + "that is discussed the consultation. Can you confirm that you are happy to proceed?"
                }}
                value="Consented"
                mandatory
            />
        </AccordionQuestionnaireSection>);
};
